import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postClientes, getClientes } from "../../redux/actions/actionClient";

export default function ClientsCreate() {
  const initialForm = {
    //idClient: "",
    cuit: "",
    name: "",
    lastName: "",
    nameCompany: "",
    address: "",
    city: "",
    telephoneNumber: "",
    contactName: "",
    email: "",
    notes: ""    
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clients = useSelector((state) => state.clientes.allClientes);
  const [form, setForm] = useState(initialForm);
  //const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(getClientes());
  }, [dispatch]);

  //const clients = clientsObject.allClients;
  console.log(clients);

  const codigoCliente = (clients.length + 1);
  console.log(codigoCliente);

  // const handleErrors = (form) => {
  //   let errors = {};
  // };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
  console.log(form)
  const handleSubmit = () => {    
    dispatch(postClientes(form));
    setForm({
      cuit: "",
      //idClient: "",
      name: "",
      lastName: "",
      nameCompany: "",
      address: "",
      city: "",
      telephoneNumber: "",
      contactName: "",
      email: "",
      notes: ""      
    });
    setTimeout(() => {
      navigate("/clientes/listado")
    }, 300);
  };

  return (
    <div className="min-w-full max-w-screen-2xl bg-gray-900">
      <form onSubmit={handleSubmit}>
        <div className="m-8 text-orange-500 font-bold">
        <div>
                <p className="text-xl pb-8 underline">Clientes - Nuevo</p>
            </div>
          
          <div className="flex">  
            <label className="w-40">Código Cliente</label>          
            <input
              className="w-28 text-center bg-slate-700"
              type="text"
              name="idClient"
              placeholder="id"
              onChange={handleChange}
              value={codigoCliente}
              required={true}
            />         
          </div>
          <div className="flex mt-4 mb-4">            
              <label className="w-40">CUIT</label>            
              <input
                className="w-1/3 text-center bg-slate-700"
                type="text"
                name="cuit"
                placeholder="CUIT"
                onChange={handleChange}
                value={form.cuit}
                required={true}
              />
          </div>
                                                        {/* Nombre - Apellido */}
          <div className="flex mt-4 mb-4">            
              <label className="w-40">Nombre</label>            
              <input
                className="w-1/3 text-center bg-slate-700"
                type="text"
                name="name"
                placeholder="Nombre Cliente"
                onChange={handleChange}
                value={form.name}
                required={true}
              />
          </div>  
          <div className="flex mb-4">          
              <label className="w-40">Apellido</label>
              <input
                className="w-1/3 text-center bg-slate-700"
                type="text"
                name="lastName"
                placeholder="Apellido"
                onChange={handleChange}
                value={form.lastName}
                required={true}
              />
          </div>
                                                              {/* Nombre de Compañia - Direccion - Ciudad */}
          <div className="flex mb-4">            
            <label className="w-40">Nombre Compañia</label>
            <input
              className="w-1/3 text-center bg-slate-700"
              type="text"
              name="nameCompany"
              placeholder="Nombre de Empresa"
              onChange={handleChange}
              value={form.nameCompany}
              required={true}
            />
          </div> 
          <div className="flex mb-4">                                 
            <label className="w-40">Dirección</label>
            <input
              className="w-1/3 text-center bg-slate-700"
              type="text"
              name="address"
              placeholder="Dirección"
              onChange={handleChange}
              value={form.address}
              required={true}
            />
          </div>
          <div className="flex mb-4">            
            <label className="w-40">Ciudad</label>
            <input
              className="w-1/3 text-center bg-slate-700"
              type="text"
              name="city"
              placeholder="Ciudad"
              onChange={handleChange}
              value={form.city}
              required={true}
            />           
          </div>
                                                     {/* Telefonos - Email - Contacto */}
          <div className="flex mb-4">
            <label className="w-40">Telefonos</label>          
            <input
              className="w-1/3 text-center bg-slate-700"
              type="text"
              name="telephoneNumber"
              placeholder="Teléfonos"
              onChange={handleChange}
              value={form.telephoneNumber}
              required={true}
            />
          </div>
          <div className="flex mb-4">
            <label className="w-40">Email</label>
            <input
              className="w-1/3 text-center bg-slate-700"
              type="text"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              value={form.email}
              required={true}
            />
          </div>
          <div className="flex mb-4">
            <label className="w-40">Contacto</label>
            <input
              className="w-1/3 text-center bg-slate-700"
              type="text"
              name="contactName"
              placeholder="Contacto"
              onChange={handleChange}
              value={form.contactName}
              required={true}
            />
          </div>
          
          <div className="flex">
            <label className="w-40">Notas</label>
            <input
              className="w-1/3 text-center bg-slate-700"
              type="text"
              name="notes"
              placeholder="Notas"
              onChange={handleChange}
              value={form.notes}
              required={true}
            />
          </div>
          <div>
            <button className="mt-12 p-4 rounded bg-sky-500 text-white hover:bg-red-600" onClick={handleSubmit}>
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

// name
// lastName
// nameCompany
// address
// telephoneNumber
// contactName
// email
// notes
